import { PlayerMedicalExaminationFilters } from '@/interfaces/filters/playerMedicalExaminationFilters';
import { UserMedicalExaminationFilters } from '@/interfaces/filters/userMedicalExaminationFilters';
import { MedicalExamination } from '@/interfaces/medicalExamination';
import { EntityResource } from './entity.resource';
import { FilterVariables } from './queryVariables/filters/filters';

/**
 * Moduł badań lekarskich
 *
 * @export
 * @class MedicalExaminationResource
 * @extends {EntityResource<MedicalExamination>}
 */
export class MedicalExaminationResource extends EntityResource<MedicalExamination> {
  protected getFields = {
    id: true,
    name: true,
    description: true,
    end: true,
    team: {
      id: true,
      name: true
    }
  };

  protected listFields = {
    id: true,
    name: true,
    end: true,
    team: {
      id: true,
      name: true
    }
  };

  protected listVariables = { ...FilterVariables };

  constructor() {
    super({ entityName: 'medicalExamination' });
  }

  /**
   * Lista badań lekarskich użytkownika
   *
   * @param {*} filters
   * @returns
   * @memberof MedicalExaminationResource
   */
  public userMedicalExaminationList(filters: UserMedicalExaminationFilters) {
    this.listQueryName = 'userMedicalExaminationList';
    this.listVariables.filters = 'UserMedicalExaminationFilters';
    return super.list(filters);
  }

  /**
   * Lista badań lekarskich zawodnika
   *
   * @param {*} filters
   * @returns
   * @memberof MedicalExaminationResource
   */
  public playerMedicalExaminationList(filters: PlayerMedicalExaminationFilters) {
    this.listQueryName = 'playerMedicalExaminationList';
    this.listVariables.filters = 'PlayerMedicalExaminationFilters';
    return super.list(filters);
  }
}

export const medicalExaminationResource = new MedicalExaminationResource();
